export default "__VITE_ASSET__06c83e60__"